import React from "react";
import { Box, BoxProps } from "./Box";

export interface ContainerProps extends BoxProps {
 size?: "sm" | "md" | "lg" | "xl" | "full";
}

const sizeClasses = {
 sm: "max-w-screen-sm",
 md: "max-w-screen-md",
 lg: "max-w-screen-lg",
 xl: "max-w-screen-xl",
 full: "max-w-full",
};

export const Container: React.FC<ContainerProps> = ({
 size = "lg",
 className = "",
 children,
 ...props
}) => {
 // Use theme content width if size is "lg" (default), otherwise use explicit size
 const useThemeWidth = size === "lg";
 const maxWidthClass = useThemeWidth ? "" : sizeClasses[size];
 const style = useThemeWidth
   ? { maxWidth: "var(--store-content-width, 80rem)" }
   : undefined;

 return (
  <Box
   className={`mx-auto px-2 ${maxWidthClass} ${className}`}
   style={style}
   {...props}
  >
   {children}
  </Box>
 );
};

export default Container;

